import {DirectDebitChangePagePlain} from "./DirectDebitChangeBasePage";
import {AjaxError} from "rxjs/ajax";
import {SETUP_DIRECT_DEBIT_REFUND} from "@falcon/services";
import {authorize, withRouter} from "@athena-portal/components";
import {DirectDebitInformationModal} from "../../../../../components/directDebit/DirectDebitInformationModal";

@authorize
export class DirectDebitChangeRefundPagePlain extends DirectDebitChangePagePlain {

    protected submitChanges(): void {
        this.setState({
            showOverlay: true
        })
        this.customerPortalService.updateDirectDebitRefund(this.policyNumber, this.state.newMandate)
            .subscribe(
                (response: any) => {
                    if (response instanceof AjaxError) {
                        if (response.status === 409) {
                            this.setState({
                                showBankValidationFailed: true,
                                accountNumberIsValid: false,
                                sortCodeIsValid: false,
                                showOverlay: false
                            })
                        }
                    } else if (!response.valid && response.ddUnsupported) {
                        this.setState({
                            ddUnsupported: response.ddUnsupported,
                            showBankValidationFailed: true,
                            accountNumberIsValid: false,
                            sortCodeIsValid: false,
                            showOverlay: false
                        })
                    } else {
                        window.sessionStorage.setItem("showPopup", "true");
                        window.sessionStorage.setItem("referrerJourney", SETUP_DIRECT_DEBIT_REFUND);
                        this.props.navigate(this.previousPage);
                        this.setState({
                            showOverlay: false,
                            showBankValidationFailed: false
                        })
                    }
                }, () => {
                    this.setState({
                        showOverlay: false
                    });
                    console.log("Something went wrong");
                });
    }

    protected renderDirectDebitInformationModal() {
        return <DirectDebitInformationModal product={this.state.product} type={DirectDebitInformationModal.DDI_TYPE_REFUND}/>;
    }

    protected getPageTitle() {
        return 'Update your direct debit details';
    }

}

export const DirectDebitChangeRefundPage = withRouter(DirectDebitChangeRefundPagePlain)
